const state = {
  feedbackComplaint: {
    detail: null,
    internalIssue: null,
    customerIssue: null,
    settlementIssue: null
  }
}

export default state
